import axios from 'axios';
export const initIframeRequest = (urlWhiteList) => {
  // iframe page
  window.addEventListener('message', async (msgEvt) => {
    const { type, request } = msgEvt.data;
    const messagePort = msgEvt.ports?.[0];
    if (!messagePort || type !== 'iframeReq') return;
    try {
      if (Array.isArray(urlWhiteList)) {
        if (!urlWhiteList.includes(request.url)) {
          throw Error('url not in whitelist');
        }
      }
      const res = await axios(request);
      messagePort?.postMessage({ response: { data: res.data } });
    } catch (e) {
      messagePort?.postMessage({ error: e });
    }
  });
};
export const initIframeAPI = () => {
  // iframe page
  window.addEventListener('message', async (msgEvt) => {
    const { type } = msgEvt.data;
    if (type === 'iframe_redirect') {
      window.location.href = msgEvt.data.url;
    }
  });
};

// 将 post 给这个 window 的消息转发到另一个 iframe 上
export const initIframeMessageForward = (toIframe, key) => {
  window.addEventListener('message', async (msgEvt) => {
    const { forward } = msgEvt.data;
    if (forward === key) {
      const port2 = msgEvt.ports?.[0];
      const transfer = [port2].filter(Boolean);
      toIframe.contentWindow.postMessage(msgEvt.data, '*', transfer);
    }
  });
};
